import { Route } from 'src/routes/Route'

export const InvalidMagicLinkRoute = Route({ path: '/invalid-magic-link' })
export type InvalidMagicLinkRoute = Route<typeof InvalidMagicLinkRoute>
